
// Live data from Shopify (read-only snapshot, 28 Oct 2026). In-store version reads stock live.
const STORE="https://kahaactivewear.co";
const DISCOUNT=""; // optional code appended to checkout — set once approved
const TIERS=[
 {key:"Mini",price:69.95,worth:100,note:""},
 {key:"Premium",price:109.95,worth:170,note:"Best value"},
 {key:"Ultimate",price:159.95,worth:240,note:""}
];
const SIZES=[["small","S","8"],["medium","M","10"],["large-1","L","12"],["xl","XL","14"],["16","16","2XL"],["18","18","3XL"],["20","20","4XL"]];
const V={
 "Mini/small":[67628389597498,2],"Mini/medium":[67628389630266,2],"Mini/large-1":[67628389663034,2],"Mini/xl":[67628389695802,1],"Mini/16":[54060430754106,0],"Mini/18":[54060430819642,0],"Mini/20":[54060430885178,0],
 "Premium/small":[67628389728570,2],"Premium/medium":[67628389761338,2],"Premium/large-1":[67628389794106,1],"Premium/xl":[67628389826874,1],"Premium/16":[54060431212858,0],"Premium/18":[54060431278394,0],"Premium/20":[54060431343930,0],
 "Ultimate/small":[67628389859642,2],"Ultimate/medium":[67628389892410,1],"Ultimate/large-1":[67628389925178,1],"Ultimate/xl":[67628389957946,0],"Ultimate/16":[54060431671610,0],"Ultimate/18":[54060431737146,0],"Ultimate/20":[54060431802682,0]
};
let tier="Premium", size=null;
const $=s=>document.querySelector(s), money=n=>"$"+n.toFixed(2);

function renderTiers(){
  $("#tiers").innerHTML=TIERS.map(t=>`<label class="tier ${t.key===tier?'on':''}" data-k="${t.key}">
    <input type="radio" name="tier" ${t.key===tier?'checked':''}>
    <span class="dot"></span>
    <span><span class="nm">${t.key}</span><br><span class="wv">Worth $${t.worth}+ ${t.price>=150?'· ships free':''}</span></span>
    <span class="pr">${money(t.price)}<small>Save $${(t.worth-t.price).toFixed(0)}+</small></span>
    ${t.note?`<span class="badge">${t.note}</span>`:''}</label>`).join("");
  document.querySelectorAll(".tier").forEach(el=>el.onclick=()=>{tier=el.dataset.k;if(size&&!V[tier+"/"+size][1])size=null;update()});
}
function renderSizes(){
  $("#sizes").innerHTML=SIZES.map(([k,l,s])=>{const q=V[tier+"/"+k][1];
    return `<button class="sz ${k===size?'on':''}" data-k="${k}" ${q?'':'disabled'} aria-label="${l} ${q?'':'sold out'}">${l}<small>${q?s:'Sold out'}</small></button>`}).join("");
  document.querySelectorAll(".sz").forEach(b=>b.onclick=()=>{size=b.dataset.k;update()});
}
function update(){
  renderTiers();renderSizes();
  const t=TIERS.find(x=>x.key===tier);
  $("#meterTx").innerHTML=`You pay <b style="color:#fff">${money(t.price)}</b> for <b style="color:var(--accent)">$${t.worth}+</b> of KAHA`;
  $("#mWorth").style.width="100%";$("#mPay").style.width=(t.price/t.worth*100)+"%";
  $("#ship").innerHTML=t.price>=150?`<b>Free shipping</b> (AU orders over $150) is included with the ${tier} box.`:`You’re <b>${money(Math.max(0,150-t.price))}</b> away from free AU shipping.`;
  const btn=$("#buyBtn"),st=$("#stock");
  if(size){const [id,q]=V[tier+"/"+size];
    btn.textContent=`Buy ${tier} box — ${money(t.price)} →`;btn.removeAttribute("disabled");
    btn.href=`${STORE}/cart/${id}:1`+(DISCOUNT?`?discount=${encodeURIComponent(DISCOUNT)}`:"");
    st.className="stock"+(q<=2?" low":"");st.textContent=q<=2?`Only ${q} left in this size`:`In stock`;
    $("#stBtn").textContent="Buy now";$("#stBtn").href=btn.href;
  } else {btn.textContent="Choose a size";btn.setAttribute("href","#sizes");st.textContent="";st.className="stock";$("#stBtn").textContent="Choose size";$("#stBtn").href="#buy"}
  $("#stName").textContent=tier+" Mystery Box";$("#stSub").textContent=`${money(t.price)} · worth $${t.worth}+`;
}
$("#buyBtn").addEventListener("click",e=>{if(!size){e.preventDefault();$("#sizes").scrollIntoView({behavior:"smooth",block:"center"});toast("Pick your usual size first")}});
function toast(m){const t=$("#toast");t.textContent=m;t.classList.add("show");setTimeout(()=>t.classList.remove("show"),2200)}
update();

// unbox signature
const ub=$("#unbox");const tog=()=>ub.classList.toggle("open");
ub.addEventListener("click",tog);ub.addEventListener("keydown",e=>{if(e.key==="Enter"||e.key===" "){e.preventDefault();tog()}});
new IntersectionObserver((es,o)=>es.forEach(e=>{if(e.isIntersecting){setTimeout(()=>ub.classList.add("open"),700);o.disconnect()}}),{threshold:.6}).observe(ub);

// faq
document.querySelectorAll(".qa button").forEach(b=>b.onclick=()=>{const q=b.parentElement;const o=q.classList.toggle("open");b.setAttribute("aria-expanded",o)});

// reveals
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target)}}),{threshold:.12,rootMargin:"0px 0px -40px 0px"});
document.querySelectorAll(".rv").forEach(el=>io.observe(el));

// sticky bar after hero, hidden when buy box visible
const sticky=$("#sticky");let pastHero=false,buyVis=false;
new IntersectionObserver(es=>{pastHero=!es[0].isIntersecting;sticky.classList.toggle("show",pastHero&&!buyVis)}).observe($(".hero"));
new IntersectionObserver(es=>{buyVis=es[0].isIntersecting;sticky.classList.toggle("show",pastHero&&!buyVis)},{threshold:.25}).observe($("#buy"));
